/**
 * Use this mixin with your form fields to do the calculations.
 */
export const benefitCalculator = {
  data() {
    return {
      qualify_amt: null,
    };
  },
  computed: {
    /**
     * Calculates age bracket and returns an integer code.
     * @return integer
     */
    age_bracket: function () {
      //var d = new Date();
      //var n = d.getFullYear();
      var current_age = parseInt(this.age);
      if (current_age >= 70 && current_age <= 74) {
        return 1;
      } else if (current_age >= 75 && current_age <= 79) {
        return 2;
      } else if (current_age >= 80 && current_age <= 84) {
        return 3;
      } else if (current_age >= 85 && current_age <= 89) {
        return 4;
      } else if (current_age >= 90 && current_age <= 94) {
        return 5;
      } else if (current_age >= 95) {
        return 6;
      } else {
        return 0;
      }
    },
    //-----------------------------------------------------------------------------
    /**
     * Returns the value of the benefit multiplier.
     * @return integer
     */
    multiplier: function () {
      var v = 0;
      if (this.health_bracket == 1) {
        switch (this.age_bracket) {
          case 1:
            v = 0.13;
            break;
          case 2:
            v = 0.18;
            break;
          case 3:
            v = 0.23;
            break;
          case 4:
            v = 0.28;
            break;
          case 5:
            v = 0.28;
            break;
          case 6:
            v = 0.28;
            break;
          default:
            v = 0.05;
            break;
        }
        return v;
      } else if (this.health_bracket == 2) {
        switch (this.age_bracket) {
          case 1:
            v = 0.2;
            break;
          case 2:
            v = 0.25;
            break;
          case 3:
            v = 0.32;
            break;
          case 4:
            v = 0.42;
            break;
          case 5:
            v = 0.42;
            break;
          case 6:
            v = 0.42;
            break;
          default:
            v = 0.06;
            break;
        }
        return v;
      } else if (this.health_bracket == 3) {
        switch (this.age_bracket) {
          case 1:
            v = 0.3;
            break;
          case 2:
            v = 0.35;
            break;
          case 3:
            v = 0.41;
            break;
          case 4:
            v = 0.52;
            break;
          case 5:
            v = 0.52;
            break;
          case 6:
            v = 0.52;
            break;
          default:
            v = 0.08;
            break;
        }
        return v;
      } else if (this.health_bracket == 4) {
        switch (this.age_bracket) {
          case 1:
            v = 0.35;
            break;
          case 2:
            v = 0.4;
            break;
          case 3:
            v = 0.42;
            break;
          case 4:
            v = 0.56;
            break;
          case 5:
            v = 0.56;
            break;
          case 6:
            v = 0.56;
            break;
          default:
            v = 0.35;
            break;
        }
        return v;
      }
      return 0;
    },
    //----------------------------------------------------------------------------
    estimate: function () {
      if (this.death_benefit) {
        return (
          "$" + parseInt(this.death_benefit * this.multiplier).toLocaleString()
        );
      }
      return 0;
    },
    //----------------------------------------------------------------------------
    /**
     * If estimate is less than 10% of benefit value,
     * they're probably not a candidate.
     * @return boolean.
     */
    is_candidate: function () {
      if (!this.health_bracket) {
        return false;
      }

      if (this.death_benefit < this.min_db) {
        return false;
      }

      // Calculate the raw estimate.
      var x = this.death_benefit * this.multiplier.toFixed(2);

      // Calculate the qualifying amount.
      var q = (this.death_benefit * 0.1).toFixed(2);

      this.qualify_amt = "$" + (this.death_benefit * 0.1).toLocaleString();

      x = parseInt(x);
      q = parseInt(q);

      if (q == 0 || x == 0) {
        return false;
      }

      if (x < q) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted: function () {},
};
